<template>
  <div id="a-pointer">
    <div class="pointer-dot"></div>
    <div class="pointer-circle">
      <svg class="pointer-inner" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="25" cy="25" r="24.5" stroke="#212222" stroke-width="0.5" />
      </svg>
    </div>
  </div>
</template>

<script>
import { app } from '@/utils/store';
import Pointer from './pointer';

export default {
  mounted() {
    app.pointer = new Pointer();
    app.pointer.init();
  },
};
</script>
